import type { Theme } from '@mui/material/styles/createTheme';
import type { TFunction } from 'i18next';
import type { SaleEventProps } from '../useSaleEvent';
import {
  G2T_SUB_ID,
  P2N_SUB_ID,
  S2N_SUB_ID,
  D2N_SUB_ID,
  UNIVERSE_YEARLY_SUB_ID,
  UNIVERSE_MONTHLY_SUB_ID,
  W2N_SUB_ID,
  V2N_SUB_ID,
} from '../../../../constants';
import Lightning from '../Lightning';

const getHalloweenSale = (_theme: Theme, t: TFunction): SaleEventProps => ({
  name: 'Halloween Sale',
  discountData: {
    discount: 40,
    discountedSubscriptions: [
      G2T_SUB_ID.YEARLY,
      P2N_SUB_ID.YEARLY,
      S2N_SUB_ID.YEARLY,
      D2N_SUB_ID.YEARLY,
      W2N_SUB_ID.YEARLY,
      V2N_SUB_ID.YEARLY,
      G2T_SUB_ID.MONTHLY,
      P2N_SUB_ID.MONTHLY,
      S2N_SUB_ID.MONTHLY,
      D2N_SUB_ID.MONTHLY,
      W2N_SUB_ID.MONTHLY,
      V2N_SUB_ID.MONTHLY,
      UNIVERSE_YEARLY_SUB_ID,
      UNIVERSE_MONTHLY_SUB_ID,
    ],
    code: 'HALLOWEEN25',
  },
  backgroundAnimation: <Lightning />,
  title: t('home.pricing.special_event_title_sale'),
  subtitle: t('home.pricing.special_event_subtitle_sale'),
  borderText: t('home.pricing.special_event_border_text_sale'),
  navigationText: t('home.pricing.special_event_navigation_sale'),
  styles: {
    paper: {
      position: 'relative',
      isolation: 'isolate',
      backgroundImage: `url('https://klangio.blob.core.windows.net/img/background/halloween.png')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
    title: {
      position: 'relative',
      zIndex: 1,
      color: '#247738',
      fontSize: '4rem',
      marginBottom: '0',
      marginTop: '.6em',
      fontFamily: 'Creepster',
      background: 'linear-gradient(to top, #2bff00 10%, #2f9d49 50%, rgb(0 0 0))',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      // @ts-ignore
      '@media (max-width: 600px)': {
        fontSize: '2.6rem',
      },
    },
    subtitle: {
      position: 'relative',
      zIndex: 1,
      fontSize: '1.4rem',
      textAlign: 'center',
      background: 'linear-gradient(to right, #247738, #247738 35%, #35e529 55%, #184422 84%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      fontFamily: 'Creepster',
    },

    card: {
      position: 'relative',
      zIndex: 1,
      boxShadow:
        '0px 0px 10px 2px #28ff00, 0px 0px 20px 6px #247738, 0px 0px 30px 12px rgba(129,53,168,.6)',
    },

    button: {
      position: 'relative',
      zIndex: 1,
      border: '1px solid #28ff00',
      color: '#28ff00',
      background: '#2d2d2d',
      fontFamily: 'Creepster',
      fontSize: '1.2rem',
      ':hover': {
        background: '#2d2d2d',
        opacity: 0.9,
        border: '1px solid #28ff00',
        boxShadow:
          '0px 0px 4px 2px #28ff00, 0px 0px 13px 3px #247738, 0px 0px 30px 12px rgba(129,53,168,.6)',
      },
    },
    radioContainer: {
      border: `2px solid #28ff00`,
      margin: '10px 0',
    },
    radioBorderText: {
      fontSize: '1.3rem',
      fontWeight: 400,
      top: '-19px',
      color: '#28ff00',
      backgroundColor: '#303031',
      fontFamily: 'Creepster',
    },
    price: {
      color: '#28ff00',
      fontSize: '2.2rem',
      fontWeight: 'lighter',
      fontFamily: 'Creepster',
    },
    bestValue: {
      color: '#28ff00',
      fontFamily: 'Creepster',
      fontSize: '1.2rem',
      fontWeight: 'lighter',
    },
    navigationButton: {
      position: 'relative',
      zIndex: 1,
      border: '1px solid #28ff00',
      color: '#28ff00',
      background: '#2d2d2d',
      fontFamily: 'Creepster',
      fontSize: '20px !important',
      padding: '0px 12px',
      ':hover': {
        background: '#2d2d2d',
        opacity: 0.9,
        border: '1px solid #28ff00',
        boxShadow:
          '0px 0px 4px 2px #28ff00, 0px 0px 13px 3px #247738, 0px 0px 30px 12px rgba(129,53,168,.6)',
      },
    },
  },
});

export { getHalloweenSale };
